// extracted by mini-css-extract-plugin
export default {"createListModalFormItem":"styles_create-list-modal-form-item__xO2z6"};